// Fill colours read from the source workbook (styles.xml + theme1.xml, tints
// resolved). The workbook uses static fills only — it has no conditional
// formatting anywhere — so these are the whole palette.
//
// Shared by KjpTable.vue and KjpSummary.vue's export so the screen and the
// downloaded file cannot drift apart.
export const KJP_COLORS = {
  headerFill: 'D0CFCF',      // header row, most columns
  headerBakiFill: 'FFC000',  // header row, the two "baki" columns — the
                             // workbook deliberately highlights remaining quota
  monthFill: 'FFF2CC',       // month cells on district rows
  totalMonthFill: 'D9D9D9',  // month cells on the JUMLAH KESELURUHAN rows
  text: '000000',
}

// CSS-ready `#`-prefixed variants of the same palette, for the on-screen table.
// Derived from KJP_COLORS so the two can never disagree.
export const KJP_CSS_COLORS = Object.keys(KJP_COLORS).reduce((acc, key) => {
  acc[key] = `#${KJP_COLORS[key]}`

  return acc
}, {})

// One colour per work scope (INFS-1454, Hanif feedback 16 Oct), defined here
// once and read by both places that identify a scope by colour: the folder-
// index tab strip and the frame round each chart panel (KjpSummary.vue,
// KjpChart.vue). Two components inlining the same three hexes is the drift
// this file exists to prevent. Screen only: the workbook has no per-scope
// colour, so neither the table nor the Excel export reads this.
//
// The three hues are far apart (red / amber / blue), so a tab and the panel
// beneath it match at a glance and the scopes cannot be confused with each
// other. The chart series keep their own two-hue meaning (SCREEN_COLORS in
// chartScreen.js: blue = actual, orange = allowance); this frame colour never
// touches a series, so the two vocabularies do not collide.
export const SCOPE_COLORS = {
  R01: '#E74C3C',
  R02: '#F0B429',
  R06: '#3A9AD9',
}

export function scopeColor(code) {
  return SCOPE_COLORS[code] || null
}

// The scope colour at the given alpha, as rgba(). Used for the dimmed
// (inactive) tab fill and the tinted panel background: both are "the same
// colour, quieter", and deriving them from SCOPE_COLORS means they cannot
// drift from it.
export function scopeTint(code, alpha) {
  const hex = SCOPE_COLORS[code]

  if (!hex) return null

  const [r, g, b] = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16))

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

// Label colour on a scope's tab. Active tab: near-black on every scope, the
// only ink that clears 4.5:1 on all three fills (red 4.9, amber 10.1, blue 6.1;
// white on the same fills is 3.8 / 1.9 / 3.1). Inactive tab, whose fill is the
// colour at 0.6 alpha over the #333333 tab bar: white wins on red (6.3) and blue (5.3)
// but fails on amber (3.7, against 5.1 for dark), so amber keeps dark ink.
export const SCOPE_TAB_INK = {
  R01: { active: '#111111', dimmed: '#ffffff' },
  R02: { active: '#111111', dimmed: '#111111' },
  R06: { active: '#111111', dimmed: '#ffffff' },
}
